import http from '@/lib/http';

export default http({ name: 'student', path: '/students' });
